<template>
  <div>
    <div class="tabs hidden-print">
      <ul v-sticky sticky-offset="offset">
        <RouterLink
          v-slot="{ href, navigate, isActive }"
          :to="{ name: 'marketing.coupons.list.active' }"
          custom
        >
          <li :class="[isActive && 'router-link-active is-active']" role="link">
            <a :href="href" @keypress.enter="navigate" @click="navigate">
              Ενεργά Κουπόνια
            </a>
          </li>
        </RouterLink>
        <RouterLink
          v-slot="{ href, navigate, isActive }"
          :to="{ name: 'marketing.coupons.list.inactive' }"
          custom
        >
          <li :class="[isActive && 'router-link-active is-active']" role="link">
            <a :href="href" @keypress.enter="navigate" @click="navigate">
              Μη Ενεργά Κουπόνια
            </a>
          </li>
        </RouterLink>
        <RouterLink
          v-slot="{ href, navigate, isActive }"
          :to="{ name: 'marketing.coupons.list.all' }"
          custom
        >
          <li :class="[isActive && 'router-link-active is-active']" role="link">
            <a :href="href" @keypress.enter="navigate" @click="navigate">
              Όλα τα Κουπόνια
            </a>
          </li>
        </RouterLink>
        <RouterLink
          v-slot="{ href, navigate, isActive }"
          :to="{ name: 'marketing.coupons.list.deleted' }"
          custom
        >
          <li :class="[isActive && 'router-link-active is-active']" role="link">
            <a :href="href" @keypress.enter="navigate" @click="navigate">
              Ακυρωμένα Κουπόνια
            </a>
          </li>
        </RouterLink>
      </ul>
    </div>

    <router-view />
  </div>
</template>

<script>
export default {
  data: () => ({
    offset: { top: 45 },
  }),
};
</script>
